import { useCommonStore } from "@/stores";
import styles from "./index.module.scss";
import { ExpTemp, ExpTempUploader, StepDesc } from "@/components";
import { ExpTempType } from "@/constants";
import type { TExpTemp } from "@/types";
import { useTranslation } from "react-i18next";
import { useExpTempList } from "@/hooks";

type ExpTempListProps = {
  style?: object;
}

const ExpTempList = (props: ExpTempListProps) => {
  const {
    style = {},
  } = props;

  const { t } = useTranslation();
  const communityExpTempList = useCommonStore(state => state.communityExpTempList);
  const presetExpTempList = useCommonStore(state => state.presetExpTempList);
  const cusExpTempList = useCommonStore(state => state.cusExpTempList);
  const activeExpTempIndex = useCommonStore(state => state.activeExpTempIndex);
  const activeExpTempType = useCommonStore(state => state.activeExpTempType);
  const isMobile = useCommonStore(state => state.isMobile);
  const isMute = useCommonStore(state => state.isMute);
  const setIsMute = useCommonStore(state => state.setIsMute);
  const updatePlayState = useCommonStore(state => state.updatePlayState);
  const setIsPlayResult = useCommonStore(state => state.setIsPlayResult);
  const {
    handleClickCommunityExpTemp,
    handleClickPresetExpTemp,
    handleClickCusExpTemp,
  } = useExpTempList();
  
  
  const handlePlay = (e: any, item: TExpTemp) => {
    e.stopPropagation();
    updatePlayState(true, item);
    setIsPlayResult(false);
  }

  const handlePause = (e: any, item: TExpTemp) => {
    e.stopPropagation();
    updatePlayState(false, item);
  }

  const handleMute = (e: any) => {
    e.stopPropagation();
    setIsMute(true);
  }

  const handleCancelMute = (e: any) => {
    e.stopPropagation();
    setIsMute(false);
  }

  return (
    <div
      style={style}
      className={styles["exp_temp_list"]}
    >
      {!isMobile && (
        <StepDesc
          className={styles["custom_step_desc"]}
          step={2}
          desc={t("step2_desc")}
        ></StepDesc>
      )}

      <div
        className={styles["grid_wrapper"]}
      >
        {communityExpTempList.map((item, index) => (
          <ExpTemp
            key={item.id}
            {...item}
            isMute={isMobile ? false : isMute}
            active={activeExpTempType === ExpTempType.Community && activeExpTempIndex === index}
            onClick={() => handleClickCommunityExpTemp(index, item)}
            onPlay={e => handlePlay(e, item)}
            onPause={e => handlePause(e, item)}
            onMute={handleMute}
            onCancelMute={handleCancelMute}
            expTempType={ExpTempType.Community}
          ></ExpTemp>
        ))}

        {presetExpTempList.map((item, index) => (
          <ExpTemp
            key={item.id}
            {...item}
            isMute={isMobile ? false : isMute}
            active={activeExpTempType === ExpTempType.Preset && activeExpTempIndex === index}
            onClick={() => handleClickPresetExpTemp(index, item)}
            onPlay={e => handlePlay(e, item)}
            onPause={e => handlePause(e, item)}
            onMute={handleMute}
            onCancelMute={handleCancelMute}
          ></ExpTemp>
        ))}

        {cusExpTempList.map((item, index) => (
          <ExpTemp
            key={item.id}
            {...item}
            isMute={isMobile ? false : isMute}
            active={activeExpTempType === ExpTempType.Cus && activeExpTempIndex === index}
            onClick={() => handleClickCusExpTemp(index, item)}
            onPlay={e => handlePlay(e, item)}
            onPause={e => handlePause(e, item)}
            onMute={handleMute}
            onCancelMute={handleCancelMute}
          ></ExpTemp>
        ))}

        <ExpTempUploader></ExpTempUploader>
      </div>
    </div>
  )
}

export default ExpTempList;